import React from 'react';
import ClickOutsideAwareComponent from "@Features/clickOutsideAwareComponent/components/ClickOutsideAwareComponent";
import Translation from "@Translation/components/Translation";
import MenuItem from "@Header/components/TopBar/MenuItem";
import {Colors} from "@Styles/Colors.style";
import IconChevron from "@Icons/chevrons/IconChevron";
import {useHandleMainMenu} from "@Header/hooks/useHandleMainMenu";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {PagesType} from "@/types/pageSlice/Pages.type";
import UrlObjectType from "@/types/pageSlice/UrlObject.type";
import useCompanyStyle from "@Hooks/selector/useCompanyStyle";

function MainMenu({topBarRef}: { topBarRef: React.RefObject<HTMLDivElement> }) {
    const {currentRoute} = window;
    const urlsObject = useAppSelector((state) => state?.page.urlsObject);
    const {company_id: companyId} = useCompanyStyle();
    const menuItems = Object.entries(urlsObject).filter(([_, urlObject]) => urlObject.text !== ''
        && !(companyId === "815" && urlObject.routeName === "gbb_front_faq")
        && !(urlObject.routeName === "help_center" || urlObject.routeName === "trvl_help_center")) as [PagesType, UrlObjectType][]
    const {
        setDropdown,
        moreMenuList,
        showDropdown,
        toggleDropdown,
        visibleMenuList,
    } = useHandleMainMenu(topBarRef, menuItems);

    return (
        <>
            {visibleMenuList.map((entry) => (
                <MenuItem
                    entry={entry}
                    currentRoute={currentRoute}
                    visible
                    key={entry[0]}
                />
            ))}
            {moreMenuList.length > 0 && (
                <ClickOutsideAwareComponent onClickOutside={() => setDropdown(false)}>
                    <ul className="gb--menu__item">
                        <li>
                            <span
                                onClick={toggleDropdown()}
                            >
                                <Translation translationKey="sys.more"/>
                                <IconChevron height="16" fill={Colors.neutralWhiteColor}/>
                            </span>
                            <ul className={`select__list ${showDropdown ? 'select__list--opened' : ''}`}>
                                {moreMenuList.map((entry) => (
                                    <MenuItem
                                        entry={entry}
                                        currentRoute={currentRoute}
                                        key={entry[0]}
                                    />
                                ))}
                            </ul>
                        </li>
                    </ul>
                </ClickOutsideAwareComponent>
            )}
        </>
    );
}

export default MainMenu;
